import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface ReservationState {
  reservationKey: string | null;
  setReservationKey: (key: string | null) => void;
  resetReservation: () => void;
  hasHydrated: boolean;
  setHasHydrated: (state: boolean) => void;
  termsAccepted: boolean;
  setTermsAccepted: (accepted: boolean) => void;
}

export const useBookingStore = create<ReservationState>()(
  persist(
    (set) => ({
      reservationKey: null,
      setReservationKey: (key: string | null) => {
        set((state) => ({
          reservationKey: key,
          termsAccepted: key ? state.termsAccepted : false,
        }));
      },
      resetReservation: () => {
        set({ reservationKey: null, termsAccepted: false });
        useBookingStore.persist.clearStorage();
      },
      hasHydrated: false,
      setHasHydrated: (state: boolean) => set({ hasHydrated: state }),
      termsAccepted: false,
      setTermsAccepted: (accepted: boolean) => set({ termsAccepted: accepted }),
    }),
    {
      name: "booking-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
